<template>
  <ym-loadmore class="company-news-list-component"
               v-model="loading"
               :finished="allLoad"
               @load="fetchData"
  >
    <item v-for="(item, index) in list"
          :key="index"
          :item="item"
    />
  </ym-loadmore>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import { getArticleList } from '@/services/article';
  import Item from '@/pages/Article/components/ArticleItem';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'ArticleList',
    components: {
      'ym-loadmore': Loadmore,
      Item,
    },
    data() {
      return {
        start: 0,
        list: [],
        allLoad: false,
        loading: false,
      };
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;
        this.loading = true;

        const { query } = this.$route;
        const type = query.type ? query.type : 'companyNews';
        const data = await getArticleList({
          start: this.start,
          limit: LIMIT,
          type,
        }, isLoadMore);
        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.start = data.start;
        this.list = [...this.list, ...data.list];
        this.loading = false;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .company-news-list-component {
    padding: @size-base 0;
    background: @color-white;
  }
</style>
